import React, { useMemo, useState } from 'react'
import { DatePicker } from 'antd'
import moment from 'moment'
import { canViewStoreName as checkStoreName } from '../../../services/StorageServices'

const { MonthPicker } = DatePicker

const TableStorePackageItem = (props) => {

    const { month1, month2, onChangeMonth2, storePackageReportItem } = props
    const canViewStoreName = checkStoreName()
    const [sortBy, setSortBy] = useState('prevPackageIssueTotal')
    const [time, setTime] = useState('previous')

    const [sortPrevPackageIssueTotal, setSortPrevPackageIssueTotal] = useState(true)
    const [sortPrevPackageTotal, setSortPrevPackageTotal] = useState(true)
    const [sortPrevPercent, setSortPrevPercent] = useState(true)
    const [sortPrevApprove, setSortPrevApprove] = useState(true)
    const [sortPrevHalf, setSortPrevHalf] = useState(true)
    const [sortPrevReject, setSortPrevReject] = useState(true)


    const [sortTargetPackageIssueTotal, setSortTargetPackageIssueTotal] = useState(true)
    const [sortTargetPackageTotal, setSortTargetPackageTotal] = useState(true)
    const [sortTargetPercent, setSortTargetPercent] = useState(true)
    const [sortTargetApprove, setSortTargetApprove] = useState(true)
    const [sortTargetHalf, setSortTargetHalf] = useState(true)
    const [sortTargetReject, setSortTargetReject] = useState(true)

    const showPercentIssue = (number, total) => {
        if (total === 0) return 0

        const percent = ((+number / +total) * 100)
        return !!percent ? Number(percent.toFixed(2)) : 0
    }

    const {
        groupByStore = {},
        prevPackageIssueTotal = 0,
        prevApprovedIssueTotal = 0,
        prevHalfIssueTotal = 0,
        prevRejectIssueTotal = 0,
        prevPackageTotal = 0,
        targetPackageIssueTotal = 0,
        targetApprovedIssueTotal = 0,
        targetHalfIssueTotal = 0,
        targetRejectIssueTotal = 0,
        targetPackageTotal = 0
    } = Object.assign({}, storePackageReportItem)

    const data = useMemo(() => {
        return Object.entries(groupByStore).map(([key, value]) => ({
            store: key,
            ...value
        }))
    }, [storePackageReportItem])

    const dataSorted = React.useMemo(() => {
        if (sortBy === 'prevPackageIssueTotal') {
            if (sortPrevPackageIssueTotal) {
                return data.sort((a, b) => a[time].packageIssues.total - b[time].packageIssues.total)
            } else {
                return data.sort((a, b) => b[time].packageIssues.total - a[time].packageIssues.total)
            }
        }

        if (sortBy === 'prevApprovedIssueTotal') {
            if (sortPrevApprove) {
                return data.sort((a, b) => a[time].packageIssues.approve - b[time].packageIssues.approve)
            } else {
                return data.sort((a, b) => b[time].packageIssues.approve - a[time].packageIssues.approve)
            }
        }

        if (sortBy === 'prevHalfIssueTotal') {
            if (sortPrevHalf) {
                return data.sort((a, b) => a[time].packageIssues.half - b[time].packageIssues.half)
            } else {
                return data.sort((a, b) => b[time].packageIssues.half - a[time].packageIssues.half)
            }
        }

        if (sortBy === 'prevRejectIssueTotal') {
            if (sortPrevReject) {
                return data.sort((a, b) => a[time].packageIssues.reject - b[time].packageIssues.reject)
            } else {
                return data.sort((a, b) => b[time].packageIssues.reject - a[time].packageIssues.reject)
            }
        }

        if (sortBy === 'prevPackageTotal') {
            if (sortPrevPackageTotal) {
                return data.sort((a, b) => a[time].packageTotal - b[time].packageTotal)
            } else {
                return data.sort((a, b) => b[time].packageTotal - a[time].packageTotal)
            }
        }

        if (sortBy === 'prevPercent') {
            if (sortPrevPercent) {
                return data.sort((a, b) => {
                    const a1 = Number(((a[time].packageIssues.total / (a[time].packageTotal || 0)) * 100))
                    const b1 = Number(((b[time].packageIssues.total / (b[time].packageTotal || 0)) * 100))
                    return a1 - b1
                })
            } else {
                return data.sort((a, b) => {
                    const a1 = Number(((a[time].packageIssues.total / (a[time].packageTotal || 0)) * 100))
                    const b1 = Number(((b[time].packageIssues.total / (b[time].packageTotal || 0)) * 100))
                    return b1 - a1
                })
            }
        }

        if (sortBy === "targetPackageIssueTotal") {
            if (sortTargetPackageIssueTotal) {
                return data.sort((a, b) => a[time].packageIssues.total - b[time].packageIssues.total)
            } else {
                return data.sort((a, b) => b[time].packageIssues.total - a[time].packageIssues.total)
            }
        }

        if (sortBy === 'targetApprovedIssueTotal') {
            if (sortTargetApprove) {
                return data.sort((a, b) => a[time].packageIssues.approve - b[time].packageIssues.approve)
            } else {
                return data.sort((a, b) => b[time].packageIssues.approve - a[time].packageIssues.approve)
            }
        }

        if (sortBy === 'targetHalfIssueTotal') {
            if (sortTargetHalf) {
                return data.sort((a, b) => a[time].packageIssues.half - b[time].packageIssues.half)
            } else {
                return data.sort((a, b) => b[time].packageIssues.half - a[time].packageIssues.half)
            }
        }

        if (sortBy === 'targetRejectIssueTotal') {
            if (sortTargetReject) {
                return data.sort((a, b) => a[time].packageIssues.reject - b[time].packageIssues.reject)
            } else {
                return data.sort((a, b) => b[time].packageIssues.reject - a[time].packageIssues.reject)
            }
        }

        if (sortBy === 'targetPackageTotal') {
            if (sortTargetPackageTotal) {
                return data.sort((a, b) => a[time].packageTotal - b[time].packageTotal)
            } else {
                return data.sort((a, b) => b[time].packageTotal - a[time].packageTotal)
            }
        }

        if (sortBy === 'targetPercent') {
            if (sortTargetPercent) {
                return data.sort((a, b) => {
                    const a1 = Number(((a[time].packageIssues.total / (a[time].packageTotal || 0)) * 100))
                    const b1 = Number(((b[time].packageIssues.total / (b[time].packageTotal || 0)) * 100))
                    return a1 - b1
                })
            } else {
                return data.sort((a, b) => {
                    const a1 = Number(((a[time].packageIssues.total / (a[time].packageTotal || 0)) * 100))
                    const b1 = Number(((b[time].packageIssues.total / (b[time].packageTotal || 0)) * 100))
                    return b1 - a1
                })
            }
        }

    }, [
        data,
        sortBy,
        sortPrevHalf,
        sortPrevReject,
        sortTargetHalf,
        sortPrevPercent,
        sortPrevApprove,
        sortTargetReject,
        sortTargetApprove,
        sortTargetPercent,
        sortPrevPackageTotal,
        sortTargetPackageTotal,
        sortPrevPackageIssueTotal,
        sortTargetPackageIssueTotal,
    ])

    const handleSortPackage = (field, sortField, setSort, time) => {
        setTime(time)
        setSortBy(field)
        setSort(!sortField)
    }

    const renderTable = ({
        className,
        month,
        onChangeMonth,
        packageIssueTotal,
        keySortPackageIssueTotal,
        sortPackageIssueTotal,
        setPackageIssueTotal,
        approvedIssueTotal,
        keySortApprove,
        sortApprove,
        setSortApprove,
        halfIssueTotal,
        keySortHalf,
        sortHalf,
        setSortHalf,
        rejectIssueTotal,
        keySortReject,
        sortReject,
        setSortReject,
        packageTotal,
        keySortPackageTotal,
        sortPackageTotal,
        setSortPackageTotal,
        keySortPercent,
        sortPercent,
        setSortPercent,
        key,
        dataMap
    }) => {
        return (
            <table className={className}>
                <thead>
                    <tr>
                        {
                            key !== 'target' && canViewStoreName &&
                            <th rowSpan={4} className='col-store'>Store</th>
                        }
                        <th colSpan={6} className="text-center">
                            {
                                key === "target" ?
                                    <MonthPicker
                                        allowClear={false}
                                        value={month}
                                        onChange={onChangeMonth}
                                        format="MMMM YYYY"
                                        className='custom-month-issue-report-store'
                                    /> : <MonthPicker
                                        allowClear={false}
                                        value={month}
                                        format="MMMM YYYY"
                                        style={{ pointerEvents: 'none' }}
                                        className='custom-month-issue-report-store'
                                    />
                            }
                        </th>
                    </tr>
                    <tr>
                        <th rowSpan={2} style={{ verticalAlign: 'middle', textAlign: 'center' }}>Tổng item lỗi</th>
                        <th colSpan={3} className='col-supplier-confirm text-center'>Kết quả duyệt</th>
                        <th rowSpan={2} style={{ verticalAlign: 'middle', textAlign: 'center' }}>Tổng item</th>
                        <th rowSpan={2} style={{ verticalAlign: 'middle', textAlign: 'center' }}>Tỷ lệ item lỗi</th>
                    </tr>
                    <tr>
                        <th>Approve</th>
                        <th>50/50</th>
                        <th>Reject</th>
                    </tr>
                    <tr>
                        <th className='text-right'>
                            {packageIssueTotal}
                            {
                                sortPackageIssueTotal ?
                                    <i
                                        className={`fa fa-long-arrow-up cursor-pointer p-1 ${sortBy === keySortPackageIssueTotal && "text-primary"}`}
                                        onClick={() => handleSortPackage(keySortPackageIssueTotal, sortPackageIssueTotal, setPackageIssueTotal, key)}
                                    /> :
                                    <i
                                        className={`fa fa-long-arrow-down cursor-pointer p-1 ${sortBy === keySortPackageIssueTotal && "text-primary"}`}
                                        onClick={() => handleSortPackage(keySortPackageIssueTotal, sortPackageIssueTotal, setPackageIssueTotal, key)}
                                    />
                            }
                        </th>
                        <th className='text-right'>
                            {approvedIssueTotal}
                            {
                                sortApprove ?
                                    <i
                                        className={`fa fa-long-arrow-up cursor-pointer p-1 ${sortBy === keySortApprove && "text-primary"}`}
                                        onClick={() => handleSortPackage(keySortApprove, sortApprove, setSortApprove, key)}
                                    /> :
                                    <i
                                        className={`fa fa-long-arrow-down cursor-pointer p-1 ${sortBy === keySortApprove && "text-primary"}`}
                                        onClick={() => handleSortPackage(keySortApprove, sortApprove, setSortApprove, key)}
                                    />
                            }
                        </th>
                        <th className='text-right'>
                            {halfIssueTotal}
                            {
                                sortHalf ?
                                    <i
                                        className={`fa fa-long-arrow-up cursor-pointer p-1 ${sortBy === keySortHalf && "text-primary"}`}
                                        onClick={() => handleSortPackage(keySortHalf, sortHalf, setSortHalf, key)}
                                    /> :
                                    <i
                                        className={`fa fa-long-arrow-down cursor-pointer p-1 ${sortBy === keySortHalf && "text-primary"}`}
                                        onClick={() => handleSortPackage(keySortHalf, sortHalf, setSortHalf, key)}
                                    />
                            }
                        </th>
                        <th className='text-right'>
                            {rejectIssueTotal}
                            {
                                sortReject ?
                                    <i
                                        className={`fa fa-long-arrow-up cursor-pointer p-1 ${sortBy === keySortReject && "text-primary"}`}
                                        onClick={() => handleSortPackage(keySortReject, sortReject, setSortReject, key)}
                                    /> :
                                    <i
                                        className={`fa fa-long-arrow-down cursor-pointer p-1 ${sortBy === keySortReject && "text-primary"}`}
                                        onClick={() => handleSortPackage(keySortReject, sortReject, setSortReject, key)}
                                    />
                            }
                        </th>
                        <th className='text-right'>
                            {packageTotal}
                            {
                                sortPackageTotal ?
                                    <i
                                        className={`fa fa-long-arrow-up cursor-pointer p-1 ${sortBy === keySortPackageTotal && "text-primary"}`}
                                        onClick={() => handleSortPackage(keySortPackageTotal, sortPackageTotal, setSortPackageTotal, key)}
                                    /> :
                                    <i
                                        className={`fa fa-long-arrow-down cursor-pointer p-1 ${sortBy === keySortPackageTotal && "text-primary"}`}
                                        onClick={() => handleSortPackage(keySortPackageTotal, sortPackageTotal, setSortPackageTotal, key)}
                                    />
                            }
                        </th>
                        <th className='text-right'>
                            {`${showPercentIssue(packageIssueTotal, packageTotal)}%`}
                            {
                                sortPercent ?
                                    <i
                                        className={`fa fa-long-arrow-up cursor-pointer p-1 ${sortBy === keySortPercent && "text-primary"}`}
                                        onClick={() => handleSortPackage(keySortPercent, sortPercent, setSortPercent, key)}
                                    /> :
                                    <i
                                        className={`fa fa-long-arrow-down cursor-pointer p-1 ${sortBy === keySortPercent && "text-primary"}`}
                                        onClick={() => handleSortPackage(keySortPercent, sortPercent, setSortPercent, key)}
                                    />
                            }
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {dataMap.map((row, index) => {
                        const { previous = {}, target = {}, store = '' } = Object.assign({}, row)
                        const { packageIssues = {}, packageTotal = 0 } = Object.assign({}, key === 'target' ? target : previous)
                        const { total = 0, reject = 0, half = 0, approve = 0 } = Object.assign({}, packageIssues)
                        const isNotification = showPercentIssue(total, packageTotal) > 2
                        return (
                            <tr key={index}>
                                {key !== 'target' && canViewStoreName && <td className='col-store'>{store}</td>}
                                <td className='text-right' style={{ backgroundColor: isNotification ? "#f7d9da" : 'transparent' }}>{total}</td>
                                <td className='text-right' style={{ backgroundColor: isNotification ? "#f7d9da" : 'transparent' }}>{approve}</td>
                                <td className='text-right' style={{ backgroundColor: isNotification ? "#f7d9da" : 'transparent' }}>{half}</td>
                                <td className='text-right' style={{ backgroundColor: isNotification ? "#f7d9da" : 'transparent' }}>{reject}</td>
                                <td className='text-right' style={{ backgroundColor: isNotification ? "#f7d9da" : 'transparent' }}>{packageTotal}</td>
                                <td className='text-right' style={{ backgroundColor: isNotification ? "#f7d9da" : 'transparent' }}>{`${showPercentIssue(total, packageTotal)}%`}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        )
    }

    return (
        <div className="table IssuePackageItem d-flex">
            {
                renderTable({
                    className: 'table-left',
                    month: month1,
                    packageIssueTotal: prevPackageIssueTotal,
                    keySortPackageIssueTotal: "prevPackageIssueTotal",
                    sortPackageIssueTotal: sortPrevPackageIssueTotal,
                    setPackageIssueTotal: setSortPrevPackageIssueTotal,
                    approvedIssueTotal: prevApprovedIssueTotal,
                    keySortApprove: "prevApprovedIssueTotal",
                    sortApprove: sortPrevApprove,
                    setSortApprove: setSortPrevApprove,
                    halfIssueTotal: prevHalfIssueTotal,
                    keySortHalf: "prevHalfIssueTotal",
                    sortHalf: sortPrevHalf,
                    setSortHalf: setSortPrevHalf,
                    rejectIssueTotal: prevRejectIssueTotal,
                    keySortReject: "prevRejectIssueTotal",
                    sortReject: sortPrevReject,
                    setSortReject: setSortPrevReject,
                    packageTotal: prevPackageTotal,
                    keySortPackageTotal: "prevPackageTotal",
                    sortPackageTotal: sortPrevPackageTotal,
                    setSortPackageTotal: setSortPrevPackageTotal,
                    keySortPercent: "prevPercent",
                    sortPercent: sortPrevPercent,
                    setSortPercent: setSortPrevPercent,
                    key: 'previous',
                    dataMap: dataSorted,
                })
            }
            {
                renderTable({
                    className: 'table-right',
                    month: month2,
                    onChangeMonth: onChangeMonth2,
                    packageIssueTotal: targetPackageIssueTotal,
                    sortPackageIssueTotal: sortTargetPackageIssueTotal,
                    setPackageIssueTotal: setSortTargetPackageIssueTotal,
                    approvedIssueTotal: targetApprovedIssueTotal,
                    sortApprove: sortTargetApprove,
                    setSortApprove: setSortTargetApprove,
                    halfIssueTotal: targetHalfIssueTotal,
                    sortHalf: sortTargetHalf,
                    setSortHalf: setSortTargetHalf,
                    rejectIssueTotal: targetRejectIssueTotal,
                    sortReject: sortTargetReject,
                    setSortReject: setSortTargetReject,
                    packageTotal: targetPackageTotal,
                    sortPackageTotal: sortTargetPackageTotal,
                    setSortPackageTotal: setSortTargetPackageTotal,
                    sortPercent: sortTargetPercent,
                    setSortPercent: setSortTargetPercent,
                    key: 'target',
                    dataMap: dataSorted,
                    keySortPackageIssueTotal: "targetPackageIssueTotal",
                    keySortApprove: "targetApprovedIssueTotal",
                    keySortHalf: "targetHalfIssueTotal",
                    keySortReject: "targetRejectIssueTotal",
                    keySortPackageTotal: "targetPackageTotal",
                    keySortPercent: "targetPercent",
                })
            }

            <table className="table" style={{ display: 'none' }} id="Issue_Store_Package_Item_Report">
                <thead style={{ display: 'none' }}>
                    <tr>
                        {canViewStoreName && <th rowSpan={4} className='col-store'>Store</th>}
                        <th colSpan={6} className="text-center">
                            {moment(month1).format('MMMM YYYY')}
                        </th>
                        <th colSpan={6} className="text-center">
                            {moment(month2).format('MMMM YYYY')}
                        </th>
                    </tr>
                    <tr>
                        <th rowSpan={2} style={{ verticalAlign: 'middle', textAlign: 'center' }}>Tổng item lỗi</th>
                        <th colSpan={3} className='col-supplier-confirm text-center'>Kết quả duyệt</th>
                        <th rowSpan={2} style={{ verticalAlign: 'middle', textAlign: 'center' }}>Tổng item</th>
                        <th rowSpan={2} style={{ verticalAlign: 'middle', textAlign: 'center' }}>Tỷ lệ item lỗi</th>
                        <th rowSpan={2} style={{ verticalAlign: 'middle', textAlign: 'center' }}>Tổng item lỗi</th>
                        <th colSpan={3} className='col-supplier-confirm text-center'>Kết quả duyệt</th>
                        <th rowSpan={2} style={{ verticalAlign: 'middle', textAlign: 'center' }}>Tổng item</th>
                        <th rowSpan={2} style={{ verticalAlign: 'middle', textAlign: 'center' }}>Tỷ lệ item lỗi</th>
                    </tr>
                    <tr>
                        <th>Approve</th>
                        <th>50/50</th>
                        <th>Reject</th>
                        <th>Approve</th>
                        <th>50/50</th>
                        <th>Reject</th>
                    </tr>
                    <tr>
                        <th className='text-right'>
                            {prevPackageIssueTotal}
                            {
                                !sortPrevPackageIssueTotal ?
                                    <i
                                        className={`fa fa-long-arrow-down cursor-pointer p-1 ${sortBy === "prevPackageIssueTotal" && "text-primary"}`}
                                        onClick={() => handleSortPackage('prevPackageIssueTotal', sortPrevPackageIssueTotal, setSortPrevPackageIssueTotal, 'previous')}
                                    /> :
                                    <i
                                        className={`fa fa-long-arrow-up cursor-pointer p-1 ${sortBy === "prevPackageIssueTotal" && "text-primary"}`}
                                        onClick={() => handleSortPackage('prevPackageIssueTotal', sortPrevPackageIssueTotal, setSortPrevPackageIssueTotal, 'previous')}
                                    />
                            }
                        </th>
                        <th className='text-right'>
                            {prevApprovedIssueTotal}
                            {
                                !sortPrevApprove ?
                                    <i
                                        className={`fa fa-long-arrow-down cursor-pointer p-1 ${sortBy === "prevApprovedIssueTotal" && "text-primary"}`}
                                        onClick={() => handleSortPackage('prevApprovedIssueTotal', sortPrevApprove, setSortPrevApprove, 'previous')}
                                    /> :
                                    <i
                                        className={`fa fa-long-arrow-up cursor-pointer p-1 ${sortBy === "prevApprovedIssueTotal" && "text-primary"}`}
                                        onClick={() => handleSortPackage('prevApprovedIssueTotal', sortPrevApprove, setSortPrevApprove, 'previous')}
                                    />
                            }
                        </th>
                        <th className='text-right'>
                            {prevHalfIssueTotal}
                            {
                                !sortPrevHalf ?
                                    <i
                                        className={`fa fa-long-arrow-down cursor-pointer p-1 ${sortBy === "prevHalfIssueTotal" && "text-primary"}`}
                                        onClick={() => handleSortPackage('prevHalfIssueTotal', sortPrevHalf, setSortPrevHalf, 'previous')}
                                    /> :
                                    <i
                                        className={`fa fa-long-arrow-up cursor-pointer p-1 ${sortBy === "prevHalfIssueTotal" && "text-primary"}`}
                                        onClick={() => handleSortPackage('prevHalfIssueTotal', sortPrevHalf, setSortPrevHalf, 'previous')}
                                    />
                            }
                        </th>
                        <th className='text-right'>
                            {prevRejectIssueTotal}
                            {
                                !sortPrevReject ?
                                    <i
                                        className={`fa fa-long-arrow-down cursor-pointer p-1 ${sortBy === "prevRejectIssueTotal" && "text-primary"}`}
                                        onClick={() => handleSortPackage('prevRejectIssueTotal', sortPrevReject, setSortPrevReject, 'previous')}
                                    /> :
                                    <i
                                        className={`fa fa-long-arrow-up cursor-pointer p-1 ${sortBy === "prevRejectIssueTotal" && "text-primary"}`}
                                        onClick={() => handleSortPackage('prevRejectIssueTotal', sortPrevReject, setSortPrevReject, 'previous')}
                                    />
                            }
                        </th>
                        <th className='text-right'>
                            {prevPackageTotal}
                            {
                                !sortPrevPackageTotal ?
                                    <i
                                        className={`fa fa-long-arrow-down cursor-pointer p-1 ${sortBy === "prevPackageTotal" && "text-primary"}`}
                                        onClick={() => handleSortPackage('prevPackageTotal', sortPrevPackageTotal, setSortPrevPackageTotal, 'previous')}
                                    /> :
                                    <i
                                        className={`fa fa-long-arrow-up cursor-pointer p-1 ${sortBy === "prevPackageTotal" && "text-primary"}`}
                                        onClick={() => handleSortPackage('prevPackageTotal', sortPrevPackageTotal, setSortPrevPackageTotal, 'previous')}
                                    />
                            }
                        </th>
                        <th className='text-right'>
                            {`${showPercentIssue(prevPackageIssueTotal, prevPackageTotal)}%`}
                            {
                                !sortPrevPercent ?
                                    <i
                                        className={`fa fa-long-arrow-down cursor-pointer p-1 ${sortBy === "prevPercent" && "text-primary"}`}
                                        onClick={() => handleSortPackage('prevPercent', sortPrevPercent, setSortPrevPercent, 'previous')}
                                    /> :
                                    <i
                                        className={`fa fa-long-arrow-up cursor-pointer p-1 ${sortBy === "prevPercent" && "text-primary"}`}
                                        onClick={() => handleSortPackage('prevPercent', sortPrevPercent, setSortPrevPercent, 'previous')}
                                    />
                            }
                        </th>
                        <th className='text-right'>
                            {targetPackageIssueTotal}
                            {
                                sortPrevPackageIssueTotal ?
                                    <i
                                        onClick={() => handleSortPackage('targetPackageIssueTotal', sortTargetPackageIssueTotal, setSortTargetPackageIssueTotal, 'target')}
                                        className={`fa fa-long-arrow-up cursor-pointer p-1 ${sortBy === "targetPackageIssueTotal" && "text-primary"}`}
                                    /> :
                                    <i
                                        onClick={() => handleSortPackage('targetPackageIssueTotal', sortTargetPackageIssueTotal, setSortTargetPackageIssueTotal, 'target')}
                                        className={`fa fa-long-arrow-down cursor-pointer p-1 ${sortBy === "targetPackageIssueTotal" && "text-primary"}`}
                                    />
                            }
                        </th>
                        <th className='text-right'>
                            {targetApprovedIssueTotal}
                            {
                                sortTargetApprove ?
                                    <i
                                        onClick={() => handleSortPackage('targetApprovedIssueTotal', sortTargetApprove, setSortTargetApprove, 'target')}
                                        className={`fa fa-long-arrow-up cursor-pointer p-1 ${sortBy === "targetApprovedIssueTotal" && "text-primary"}`}
                                    /> :
                                    <i
                                        onClick={() => handleSortPackage('targetApprovedIssueTotal', sortTargetApprove, setSortTargetApprove, 'target')}
                                        className={`fa fa-long-arrow-down cursor-pointer p-1 ${sortBy === "targetApprovedIssueTotal" && "text-primary"}`}
                                    />
                            }
                        </th>
                        <th className='text-right'>
                            {targetHalfIssueTotal}
                            {
                                sortTargetHalf ?
                                    <i
                                        onClick={() => handleSortPackage('targetHalfIssueTotal', sortTargetHalf, setSortTargetHalf, 'target')}
                                        className={`fa fa-long-arrow-up cursor-pointer p-1 ${sortBy === "targetHalfIssueTotal" && "text-primary"}`}
                                    /> :
                                    <i
                                        onClick={() => handleSortPackage('targetHalfIssueTotal', sortTargetHalf, setSortTargetHalf, 'target')}
                                        className={`fa fa-long-arrow-down cursor-pointer p-1 ${sortBy === "targetHalfIssueTotal" && "text-primary"}`}
                                    />
                            }
                        </th>
                        <th className='text-right'>
                            {targetRejectIssueTotal}
                            {
                                sortTargetReject ?
                                    <i
                                        onClick={() => handleSortPackage('targetRejectIssueTotal', sortTargetReject, setSortTargetReject, 'target')}
                                        className={`fa fa-long-arrow-up cursor-pointer p-1 ${sortBy === "targetRejectIssueTotal" && "text-primary"}`}
                                    /> :
                                    <i
                                        onClick={() => handleSortPackage('targetRejectIssueTotal', sortTargetReject, setSortTargetReject, 'target')}
                                        className={`fa fa-long-arrow-down cursor-pointer p-1 ${sortBy === "targetRejectIssueTotal" && "text-primary"}`}
                                    />
                            }
                        </th>
                        <th className='text-right'>
                            {targetPackageTotal}
                            {
                                sortTargetPackageTotal ?
                                    <i
                                        onClick={() => handleSortPackage('targetPackageTotal', sortTargetPackageTotal, setSortTargetPackageTotal, 'target')}
                                        className={`fa fa-long-arrow-up cursor-pointer p-1 ${sortBy === "targetPackageTotal" && "text-primary"}`}
                                    /> :
                                    <i
                                        onClick={() => handleSortPackage('targetPackageTotal', sortTargetPackageTotal, setSortTargetPackageTotal, 'target')}
                                        className={`fa fa-long-arrow-down cursor-pointer p-1 ${sortBy === "targetPackageTotal" && "text-primary"}`}
                                    />
                            }
                        </th>
                        <th className='text-right'>
                            {`${showPercentIssue(targetPackageIssueTotal, targetPackageTotal)}%`}
                            {
                                sortTargetPercent ?
                                    <i
                                        onClick={() => handleSortPackage('targetPercent', sortTargetPercent, setSortTargetPercent, 'target')}
                                        className={`fa fa-long-arrow-up cursor-pointer p-1 ${sortBy === "targetPercent" && "text-primary"}`}
                                    /> :
                                    <i
                                        onClick={() => handleSortPackage('targetPercent', sortTargetPercent, setSortTargetPercent, 'target')}
                                        className={`fa fa-long-arrow-down cursor-pointer p-1 ${sortBy === "targetPercent" && "text-primary"}`}
                                    />
                            }
                        </th>
                    </tr>
                </thead>
                <tbody style={{ display: 'none' }}>
                    {dataSorted.map((row, index) => {
                        const { previous = {}, target = {}, store = '' } = Object.assign({}, row)
                        const { packageIssues: packageIssuesTarget = {}, packageTotal: packageTotalTarget = 0 } = Object.assign({}, target)
                        const { packageIssues: packageIssuesPrev = {}, packageTotal: packageTotalPrev = 0 } = Object.assign({}, previous)

                        const isNotificationPrev = showPercentIssue(packageIssuesPrev.total, packageTotalPrev) > 2
                        const isNotificationTarget = showPercentIssue(packageIssuesTarget.total, packageTotalTarget) > 2

                        return (
                            <tr key={index}>
                                {canViewStoreName && <td className='col-store'>{store}</td>}
                                <td className='text-right' style={{ backgroundColor: isNotificationPrev ? "#f7d9da" : 'transparent' }}>{packageIssuesPrev.total}</td>
                                <td className='text-right' style={{ backgroundColor: isNotificationPrev ? "#f7d9da" : 'transparent' }}>{packageIssuesPrev.approve}</td>
                                <td className='text-right' style={{ backgroundColor: isNotificationPrev ? "#f7d9da" : 'transparent' }}>{packageIssuesPrev.half}</td>
                                <td className='text-right' style={{ backgroundColor: isNotificationPrev ? "#f7d9da" : 'transparent' }}>{packageIssuesPrev.reject}</td>
                                <td className='text-right' style={{ backgroundColor: isNotificationPrev ? "#f7d9da" : 'transparent' }}>{packageTotalPrev}</td>
                                <td className='text-right' style={{ backgroundColor: isNotificationPrev ? "#f7d9da" : 'transparent' }}>{`${showPercentIssue(packageIssuesPrev.total, packageTotalPrev)}%`}</td>

                                <td className='text-right' style={{ backgroundColor: isNotificationTarget ? "#f7d9da" : 'transparent' }}>{packageIssuesTarget.total}</td>
                                <td className='text-right' style={{ backgroundColor: isNotificationTarget ? "#f7d9da" : 'transparent' }}>{packageIssuesTarget.approve}</td>
                                <td className='text-right' style={{ backgroundColor: isNotificationTarget ? "#f7d9da" : 'transparent' }}>{packageIssuesTarget.half}</td>
                                <td className='text-right' style={{ backgroundColor: isNotificationTarget ? "#f7d9da" : 'transparent' }}>{packageIssuesTarget.reject}</td>
                                <td className='text-right' style={{ backgroundColor: isNotificationTarget ? "#f7d9da" : 'transparent' }}>{packageTotalTarget}</td>
                                <td className='text-right' style={{ backgroundColor: isNotificationTarget ? "#f7d9da" : 'transparent' }}>{`${showPercentIssue(packageIssuesTarget.total, packageTotalTarget)}%`}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    )
}

export default TableStorePackageItem